module.exports = __webpack_public_path__ + "img/icon3.ac204bf7.png";